import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import TagSelector from 'components/selectors/TagSelector';
import _ from 'lodash';
import i18n from 'i18n';
import { Tag } from 'types/rest/assetCatalogTypes';
import { SelectAllType } from 'components/blazeTable/BlazeTable.types';

interface Props {
  isBulkTaggerOpen: boolean;
  selectedAssets: any[];
  selectAllType?: SelectAllType;
  closeAssetBulkTagModalAction: () => void;
  bulkTagThunk: (selectedAssets: any[], tags: string[], selectAllType?: SelectAllType) => void;
}

const AssetBulkTagModal: React.FC<Props> = ({
  isBulkTaggerOpen,
  selectedAssets,
  selectAllType,
  closeAssetBulkTagModalAction,
  bulkTagThunk,
}) => {
  const [tags, setTags] = useState<Tag[]>([]);

  const onAddTags = () => {
    closeAssetBulkTagModalAction();
    bulkTagThunk(
      selectedAssets,
      tags.map(t => t.name),
      selectAllType,
    );
    setTags([]);
  };

  return (
    <Modal
      enforceFocus={false}
      show={isBulkTaggerOpen}
      animation={false}
      centered
      backdrop
      backdropClassName="backdrop-faded"
      onHide={closeAssetBulkTagModalAction}
    >
      <Modal.Header closeButton id="qa-bulk-tagger-modal-btn-close-icon">
        <h5 className="modal-title">{i18n.t('transactions:table.addTags')}</h5>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="qa-tag-selector-tags">
          <Form.Label>{i18n.t('transactions:table.tags')}</Form.Label>
          <TagSelector focus selectHandler={setTags} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={closeAssetBulkTagModalAction}>
          {i18n.t('common:actions.cancel')}
        </Button>
        <Button disabled={_.isEmpty(tags)} variant="primary" onClick={onAddTags}>
          {i18n.t('transactions:table.add')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetBulkTagModal;
